import { useTranslation } from 'react-i18next';

export default function FinalCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            {t('final_cta_title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-8">
            {t('final_cta_desc')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap text-sm md:text-base"
            >
              {t('final_cta_primary')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-white text-foreground-700 border border-background-200 font-semibold rounded-lg hover:bg-background-50 transition-all whitespace-nowrap text-sm md:text-base"
            >
              {t('final_cta_secondary')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}